import { expect } from 'chai';

import testGateway from '../gateway-tester';

describe('Describe gateway testing module', () => {
  it.skip('should correctly resolve promise when gateway is available', () => {});
  it.skip('should throw an error when a gateway is not available', () => {});
});
